export default __webpack_public_path__ + "static/media/bicycle300000.2aa7aa8b.jpg";